import React from "react";
import { Link } from "react-router-dom";
import { Calendar, User } from "lucide-react";

interface BlogCardProps {
  title: string;
  excerpt: string;
  author: string;
  date: string;
  imageUrl?: string | undefined;
  slug: string;
}

export const BlogCard: React.FC<BlogCardProps> = ({
  title,
  excerpt,
  author,
  date,
  imageUrl,
  slug,
}) => {
  return (
    <Link
      to={slug}
      className="bg-white/5 backdrop-blur-sm border border-white/10 text-white h-full rounded-2xl hover:border-white/30 hover:shadow-lg hover:shadow-[#00A3FF]/20 transition-all duration-300 block group"
    >
      <div className="p-6 h-full flex flex-col">
        {imageUrl && (
          <div className="mb-4 overflow-hidden rounded-lg h-48 bg-white/5">
            <img
              src={imageUrl}
              alt={title}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
          </div>
        )}

        <h3 className="text-xl font-semibold mb-3 text-white group-hover:text-transparent group-hover:bg-gradient-text group-hover:bg-clip-text transition-all duration-300">
          {title}
        </h3>
        <div className="text-gray-300 text-sm mb-4 flex-grow">
          <p className="line-clamp-4">{excerpt}</p>
        </div>

        <div className="flex items-center justify-between text-xs text-gray-400 mt-4 pt-4 border-t border-white/10">
          <div className="flex items-center gap-1">
            <User size={14} />
            <span>{author}</span>
          </div>
          <div className="flex items-center gap-1">
            <Calendar size={14} />
            <span>{date}</span>
          </div>
        </div>
      </div>
    </Link>
  );
};
